import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('userAccessStore', Object.keys(state)),
	...mapGetters('userAccessStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('userAccessStore', Object.keys(actions)),
	...mapMutations('userAccessStore', Object.keys(mutations))
};
